import { playerMovieImpressionShowed } from '@kinopoisk-int/evgen-web-events/web/player';

import { Dependencies } from '@/scenarios/legacy-player/hooks/analytics/use-dependencies';
import { useEventCallback } from '@/scenarios/legacy-player/hooks/analytics/use-event-callback';

interface UiParams {
    mainUuid: string;
    prerollsSupported: boolean;
}

interface Params {
    uiParams: UiParams;
    dependencies: Dependencies;
    callbackParams: [{ vsid: string }];
}

export function usePlayerPrerollStarted(
    uiParams: UiParams,
    eventParamsBuilder: (params: Params) => Parameters<typeof playerMovieImpressionShowed>[1]
) {
    return useEventCallback({
        event: playerMovieImpressionShowed,
        uiParams,
        eventParamsBuilder,
    });
}
